export enum GATEWAY_TYPE {
  HIGIFT = 1,
  PAYPAL = 2,
  MARAL = 3,
  BITPAY = 4,
  NGENIUS = 5,
  EZPINPAYMENT = 6,
  PROVIDER_HOSTED_PAGE = 7,
  BINANCE_PAY = 8,
  CRYPTO_GATEWAY = 9,
  CRYPTO_GATEWAY_INTERNAL = 10,
  GATEIO = 11,
  GATELIFE = 12,
  KUCOIN = 14,
  CRYPTOMUS = 13
}

export interface Gateway {
  id: number;
  title: string;
  logo: string;
  has_cashback: boolean;
  gateway_type: number;
  gateway_type_display: string;
  currency_detail: CurrencyDetail;
  client_id?: string;
}

interface CurrencyDetail {
  id: number;
  name: string;
  code: string;
  symbol: string;
  iso_code: string;
}

export interface GatewayGroup {
  id: number;
  title: string;
  logo: string;
  description: string;
  gateways_detail: GatewayDetail[];
}

export interface GatewayDetail {
  id: number;
  title: string;
  logo: string;
  has_cashback: boolean;
  can_use_for_wallet: boolean;
  can_use_for_purchase: boolean;
  gateway_type: number;
  gateway_type_display: string;
  currency_detail: CurrencyDetail;
  client_id: string;
  billing_address_required: boolean;
  description: string;
  share: string;
  payment_method_type: number;
  payment_method_type_display: string;
}

//ui only
export interface PaymentConfig {
  title: string;
  description: string;
  expandable: boolean;
  isGateway: boolean;
  value: any;
  visible: boolean;
  hasPurchase: boolean;
  hasWallet: boolean;
  selected?: boolean;
  icon?: string;
  expanded?: boolean;
  iconClass?: string;
  data?: {
    key: string;
    value: string | null;
    valueClass: string;
    errorClass: string;
  };
  error?: string;
  errorClass?: string;
  children?: {
    gateway: GatewayDetail;
    selected: boolean;
  }[];
  isList?: boolean;
}
